import apiClient from '@/utils/api-client-without-base-url';

const suffixEndpoint = 'financial/devolutions';

export default {
  create: (data) => apiClient.post(`${suffixEndpoint}`, data),
  //   update: (data) => apiClient.put(`${suffixEndpoint}/${data.id}`, data),
  getAll: () => apiClient.get(`${suffixEndpoint}`),
  update: (data) => apiClient.put(`${suffixEndpoint}/${data.orderProductId}`, data)
};